import Profile1CFData from '../../../../Static/cashflowGraphData/Cashflow-Profile1-Rajesh-Shah.json';
import Profile2CFData from '../../../../Static/cashflowGraphData/Cashflow-PROFILE2-ASHOK-DANDEM.json';
import Profile3CFData from '../../../../Static/cashflowGraphData/Cashflow-Profile3-SHAHNAWAZ-KHAN.json';
import Profile4CFData from '../../../../Static/cashflowGraphData/Cashflow-PROFILE4-PANKAJ CHAWLA.json';
import Profile5CFData from '../../../../Static/cashflowGraphData/Cashflow-Profile5-SANKAR VADHER.json';

import { getPfmType } from '../../../../Utils/storageUtils';

export const getCashFlowData = () => {
  switch (getPfmType()) {
    case 'profile_1':
      return Profile1CFData;
    case 'profile_2':
      return Profile2CFData;
    case 'profile_3':
      return Profile3CFData;
    case 'profile_4':
      return Profile4CFData;
    case 'profile_5':
      return Profile5CFData;
    default:
      return Profile1CFData;
  }
};
